import { useCallback, type FormEvent, type ReactNode } from "react";
import { FormProvider, type FieldValues, type UseFormReturn } from "react-hook-form";
import Field from "./Field";
import List from "./List";
import { cn } from "../../../lib/utils";

function Form<T extends FieldValues, TTransformed extends FieldValues = T>({
    id,
    className,
    form,
    onFinish,
    children
}: { id?: string, className?: string, form: UseFormReturn<T, unknown, TTransformed>, children: ReactNode, onFinish?: (values: TTransformed) => void }) {

    const onSubmit = useCallback((e: FormEvent<HTMLFormElement>) => {
        e.stopPropagation();
        form.handleSubmit(onFinish ?? (() => { }))(e);
    }, [form, onFinish]);

    return (
        <FormProvider {...form}>
            <form
                id={id}
                className={cn("tw-flex tw-flex-col", className)}
                onSubmit={onSubmit}
            >
                {children}
            </form>
        </FormProvider>
    );
}

Form.Field = Field;
Form.List = List;

export default Form;
export { Field, List };